import { SlideFade } from "@chakra-ui/react";
import { useEffect, useRef } from "react";

export default function Slide({
  duration = { enter: 0.3, exit: 0.3 },
  children,
  in: shouldShow,
  onEnter,
  onExit,
  unmountOnExit,
  appear,
  offsetY,
  offsetX
}) {
  const shouldShowRef = useRef(shouldShow);
  shouldShowRef.current = shouldShow;

  const isFirstRender = useRef(true);
  const shouldAppear =
    (appear && isFirstRender.current) ||
    (!isFirstRender.current && unmountOnExit);

  useEffect(() => {
    isFirstRender.current = false;
  }, []);

  const onEnd = () => {
    if (shouldShowRef.current) onEnter?.();
    else onExit?.();
  };
  return (
    <SlideFade
      offsetY={offsetY}
      offsetX={offsetX}
      onAnimationComplete={onEnd}
      in={shouldShow}
      unmountOnExit={unmountOnExit}
      {...(!shouldAppear && {
        initial: false
      })}
      transition={{
        enter: {
          duration: duration.enter
        },
        exit: {
          duration: duration.exit
        }
      }}
    >
      {children}
    </SlideFade>
  );
}
